import { HasId } from '../../../helpers/crud/edit/HasId';
import { FilterParams } from '../../../helpers/crud/repository.service';

export interface CartInput {
    /**
     * FaceIds
     */
    fAs: number[];
    /**
     * Start Date
     */
    sd: Date;
    /**
     * End Date
     */
    ed: Date;
    /**
     * Duration Spot (s)
     */
    ds: number;
    /**
     * CampaignName
     */
    cn: string;
    /**
     * Spot Ordered Number
     */
    so?: number

}

export interface CartInfos {
    /**
     * Nbr days
     *  - Nombre de jours de la diffusion
     */
    da: number;
    /**
     * Prix Hors taxe
     */
    ht: number;
    /**
     * ScreenParks
     */
    sp: CartScreenPark[];
    /**
     * Prix TTC
     */
    tt: number;
    /**
     * TVA
     */
    ta: number;
    vat?: number;
    cn: CartCampaignInfo[];
    so?: any;
}

interface CartCampaignInfo {
    cn: string;
    sd: Date;
    ed: Date;
}

export interface CartScreenPark {
    /**
     * Expender du parc d'écran
     */
    expend?: boolean;
    /**
     * Prix Hors taxe
     */
    ht?: number;
    /**
     * ScreenParkId
     */
    i: number;
    fAs: CartFace[];
}

export interface CartFace {
    /**
     * Pour masquer la face
     */
    hide?: boolean;
    /**
     * FaceId
     */
    i: number;
    /**
     * ScreenCode
     */
    sc: string;
    /**
     * Prix HT
     */
    ht: number;
    /**
     * StorageId
     */
    st: string;
    /**
     * ThumbnailStorageId
     */
    ts: string;
    /**
     * Address
     */
    a: string;
    /**
     * CityName
     */
    c: string;
    /**
     * ZipCode
     */
    zp: string;
    /**
     * IsCompatible `boolean` activité est-elle compatible
     */
    ic: boolean;
    /**
     * NotFrees : Durée durant lesquelles l'écran n'est pas disponible
     */
    nf: NotFree[];

    /**
     * PixelWidth
     */
    pw: number;
    /**
     * PixelHeight
     */
    ph: number;

}

interface NotFree {
    /**
     * Date min
     */
    di?: string;
    /**
     * Date max
     */
    da?: string;
    /**
     * Type d'indisponibilité
     */
    ic: CompatibleTypeEnum;
}

interface FaceODV {
    /**
     * Total ODV
     */
    t: number;
    /**
     * ODV pour hommes (par tranche d'age)
     */
    m: OdbByAge;
    /**
     * ODV pour femmes (par tranche d'age)
     */
    f: OdbByAge;
}

interface OdbByAge {
    12: number,
    18: number,
    25: number,
    35: number,
    45: number,
    55: number,
    65: number,
}

export enum CompatibleTypeEnum {
    NotInstall = 0,
    Full = 1,
    UnInstall = 2,
}

class ScreenLocationFilter extends FilterParams {
    organizationId: number;
    spotId?: number;
    diffDetail: boolean;
    dontOrder?: boolean;
    deleted?: boolean;
}

/**
 * Objet contenant toutes les infos d'un marker de map
 */
export interface MarkerItem extends ScreenMap {
    /**
     * Positions GPS
     */
    position?: {
        /**
         * Latitude
         */
        lat: any;
        /**
         * Longitude
         */
        lng: any;
    };
    option?: google.maps.MarkerOptions;
}

class Screen implements HasId {
    /**
     * id de l'écran
     */
    id: number;
}
class ScreenFilterParams extends FilterParams {
    id?: number;
}

export class InputFilter extends FilterParams {
    /**
     * Latitude
     */
    la?: any;
    /**
     * Faces
     */
    fAs?: any;
    /**
     * Longitude
     */
    lo?: any;
    /**
     * StartDate - Date de début de la campagne
     */
    sd?: string;
    /**
     * EndDate - Date de fin de la campagne
     */
    ed?: string;
    /**
     * ScreenId
     */
    si?: number;
    /**
     * DurationSpot
     */
    ds?: number;
    /**
     * Order Not Compatible
     * Pour trier les écrans non compatibles en 1er
     */
    ONC: boolean = false;
}

export interface ScreenMap {
    /**
     * ScreenId
     */
    i: number;
    /**
     * Latitude
     */
    la: number;
    /**
     * Longitude
     */
    lo: number;
    /**
     * ScreenParkId
     */
    sp: number;
    /**
     * FaceIds de l'écran
     */
    fAs: FaceMap[];
    /**
     * isCompatible - Activité
     */
    ic?: boolean;
}

export interface ScreenForList extends ScreenMap, HasId {
    /**
     * @deprecated use `<ScreenMap>.i` instead
     */
    id: any;
    /**
     * Adresse de l'écran
     */
    ad: string;
    /**
     * City Name
     */
    cn: string;
    /**
     * Distance
     */
    di: number;
    /**
     * Screen Code
     */
    sc: string;
    /**
     * ZipCode
     */
    zc: string;

}

export interface FaceMap {
    /**
     * FaceId
     */
    id?: number;
    /**
     * Stored File
     */
    st?: string;
    /**
     * Thumbnail
     */
    ts?: string;
    /**
     * Direction City
     */
    dc?: number;
    /**
     * ViewSide
     */
    vs?: number;
    /**
     * IsFace selected
     */
    selected?: boolean;
    /**
     * NotFrees : Durée durant lesquelles l'écran n'est pas disponible
     */
    nf: NotFree[];
    /**
     * ODVs de la face
     */
    o?: FaceODV;
    /**
     * PixelWidth
     */
    pw: number;
    /**
     * Pixel Height
     */
    ph: number
    /**
     * Price Daily
     * 
     * Prix de la face / jour
     */
    pd: number;
}
